import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="relative bg-cream pt-24 sm:pt-28 lg:pt-32 pb-12 sm:pb-16 lg:pb-20 overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-40" />
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] bg-teal-600/10 rounded-full blur-3xl opacity-50" />
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-orange-500/10 rounded-full blur-2xl opacity-30 animate-pulse" style={{ animationDuration: '4s' }} />
      </div>

      <div className="container-base relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-display font-extrabold text-gray-900 text-balance mb-4 sm:mb-6">
              Taste Joy in Every Bite
            </h1>
            <p className="text-base sm:text-lg text-gray-600 max-w-lg mx-auto lg:mx-0 mb-6 sm:mb-8">
              Alljoy Donut Co. brings you handcrafted donuts made fresh every day with premium ingredients and a lot of love.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start mb-8 sm:mb-10">
              <Link to="/menu" className="btn-primary px-6 py-3 sm:btn-lg">
                View Our Menu
              </Link>
              <Link to="/contact" className="btn-secondary px-6 py-3 sm:btn-lg">
                Catering
              </Link>
            </div>

            {/* Social Proof */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 sm:gap-5">
              <div className="flex -space-x-2">
                {['/yelp.svg', '/tripadvisor.svg', '/facebook.svg', '/google.svg'].map((icon, index) => (
                  <div
                    key={index}
                    className="w-10 h-10 rounded-full bg-white shadow-card flex items-center justify-center ring-2 ring-white"
                  >
                    <img
                      src={icon}
                      alt={`Review platform ${index + 1}`}
                      className="w-5 h-5"
                    />
                  </div>
                ))}
              </div>
              <div className="text-center sm:text-left">
                <p className="font-semibold text-gray-900">500+ Happy Customers</p>
                <div className="flex items-center justify-center sm:justify-start gap-1">
                  <div className="flex text-orange-500">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  <span className="text-body-sm text-gray-600 ml-1">4.9/5</span>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative flex justify-center lg:justify-end order-1 lg:order-2">
            {/* Glow effect behind image */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-48 h-48 sm:w-72 sm:h-72 md:w-96 md:h-96 bg-gradient-to-br from-orange-200/50 to-teal-200/30 rounded-full blur-3xl" />
            </div>
            <img
              src="/donutstack.png"
              alt="Stack of Donuts"
              className="relative w-48 sm:w-64 md:w-80 lg:w-96 xl:w-[420px] drop-shadow-2xl animate-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
